/**
 * Formats time duration from seconds to a human-readable format
 * @param {number} seconds - Time duration in seconds
 * @returns {string} Formatted time string (e.g., "1m32s", "45s", "2h15m")
 */
export const formatTimeDuration = (seconds) => {
  if (!seconds || seconds < 0) return '0s';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  if (hours > 0) {
    // Format: 2h15m or 1h30m
    return `${hours}h${minutes > 0 ? minutes : ''}m`;
  } else if (minutes > 0) {
    // Format: 1m32s or 5m0s (show 0s if no seconds)
    return `${minutes}m${remainingSeconds > 0 ? remainingSeconds : ''}s`;
  } else {
    // Format: 45s or 0s
    return `${remainingSeconds}s`;
  }
};

/**
 * Formats time duration for short displays (max 2 units)
 * @param {number} seconds - Time duration in seconds
 * @returns {string} Formatted time string (e.g., "1m32s", "45s")
 */
export const formatShortTimeDuration = (seconds) => {
  if (!seconds || seconds < 0) return '0s';
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  if (minutes > 0) {
    // Format: 1m 32s or 5m 0s (with space between minutes and seconds)
    return `${minutes}m ${remainingSeconds > 0 ? remainingSeconds : ''}s`;
  } else {
    // Format: 45s
    return `${remainingSeconds}s`;
  }
};
